import {
  AUTHORIZE_USER,
  AUTHENTICATE_USER_OTP,
  GET_ACTIVE_USER,
  INIT_URL,
  AUTH_FAILURE,
  SIGNIN_USER_CALLBACK,
  SIGNIN_USER_SUCCESS,
  USER_PROFILE_UPDATE,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  SIGNIN_USER_INITIATED,
  CREATE_CUSTOMER_FOR_USER,
  CHECK_PROFILE_STATUS, CLEAR_AUTH_FAILURE, SIGNIN_USER_COMPLETED
} from 'constants/ActionTypes'
import { toString, has, is } from 'ramda'

export const userSignUp = (type, email, returnTo ='/verifycode') => {
  return {
    type: SIGNUP_USER,
    payload: {
      type,
      email,
      returnTo
    }
  }
}
export const authorizeUser = (email = false, returnTo ='/verifycode') => {
  return {
    type: AUTHORIZE_USER,
    payload: {
      email,
      returnTo
    }
  }
}

export const authenticateUserOtp = (otp = false, email = false, returnTo ='/') => {
  return {
    type: AUTHENTICATE_USER_OTP,
    payload: {
      otp,
      email,
      returnTo
    }
  }
}

export const get_active_user = (email) => {
  return {
    type: GET_ACTIVE_USER,
    payload: {
      email
    }
  }
}

export const userSignOut = (returnTo = '/') => {
  return {
    type: SIGNOUT_USER,
    payload: {
      returnTo
    }
  }
}
export const userSignUpSuccess = (id) => {
  return {
    type: SIGNUP_USER_SUCCESS,
    payload: {
      id
    }
  }
}

export const checkProfileStatus = () => {
  return {
    type: CHECK_PROFILE_STATUS,
  }
}

export const userSignInInitiated = (hash=false) => {
  return {
    type: SIGNIN_USER_INITIATED,
    payload: {
      hash
    }
  }
}

export const userSignInCompleted = () => {
  return {
    type: SIGNIN_USER_COMPLETED
  }
}

export const createCustomer = () => {
  return {
    type: CREATE_CUSTOMER_FOR_USER
  }
}

export const userSignInCallback = (callbackHash, returnTo = null) => {
  return {
    type: SIGNIN_USER_CALLBACK,
    payload: {
      hash: callbackHash,
      returnTo: returnTo
    }
  }
}

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: {
      authUser
    }
  }
}

export const userProfileUpdate = (profile) => {
  return {
    type: USER_PROFILE_UPDATE,
    payload: {
      profile
    }
  }
}

export const userSignOutSuccess = (returnTo = null) => {
  return {
    type: SIGNOUT_USER_SUCCESS,
    payload: {returnTo}
  }
}

const isString = is(String)
const hasMessage = has('message') // real Error objects
const hasError = has('error')
const hasErrorDescription = has('errorDescription')

export const authFailure = (error) => {
  let text
  if (isString(error)) {
    text = error
  } else if (hasMessage(error)) {
    // most likely a real Error instance
    text = error.message
  } else if (hasError(error) || hasErrorDescription(error)) {
    // auth0 lib returns objects as errors with these props
    text = `${error.error}: ${error.errorDescription}`
  } else {
    text = toString(error)
  }

  return {
    type: AUTH_FAILURE,
    message: text
  }
}

export const clearAuthFailure = () => {
  return {
    type: CLEAR_AUTH_FAILURE
  }
}

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  }
}



// WEBPACK FOOTER //
// ./actions/Auth.js